import React, { useState, useEffect } from 'react';
import { API } from '../services/api';
import './LoginLogs.css';

import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

const LoginLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    limit: 100,
    username: '',
    type: '',
    startDate: '',
    endDate: ''
  });

  useEffect(() => {
    loadLogs();
  }, []);

  const loadLogs = async () => {
    setLoading(true);
    try {
      const data = await API.getLoginLogs(
        filters.limit,
        filters.username || null,
        filters.type || null,
        filters.startDate || null,
        filters.endDate || null
      );
      setLogs(data);
    } catch (error) {
      console.error('Failed to load login logs:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
  };

  const handleApplyFilters = () => {
    loadLogs();
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  const getStatusBadge = (type) => {
    return type === 'success' ? (
      <span className="badge badge-success">Success</span>
    ) : (
      <span className="badge badge-failed">Failed</span>
    );
  };

  return (
    <div className="login-logs-container">
      <div className="login-logs-header">
        <h2>Login Activity Logs</h2>
        <button onClick={loadLogs} className="refresh-button">
          Refresh
        </button>
      </div>

      <div className="filters-section">
        <div className="filter-group">
          <label>Username:</label>
          <input
            type="text"
            value={filters.username}
            onChange={(e) => handleFilterChange('username', e.target.value)}
            placeholder="Filter by username"
          />
        </div>
        <div className="filter-group">
          <label>Type:</label>
          <select
            value={filters.type}
            onChange={(e) => handleFilterChange('type', e.target.value)}
          >
            <option value="">All</option>
            <option value="success">Success</option>
            <option value="failed">Failed</option>
          </select>
        </div>
        <div className="filter-group">
          <label>Start Date:</label>
          <input
            type="date"
            value={filters.startDate}
            onChange={(e) => handleFilterChange('startDate', e.target.value)}
          />
        </div>
        <div className="filter-group">
          <label>End Date:</label>
          <input
            type="date"
            value={filters.endDate}
            onChange={(e) => handleFilterChange('endDate', e.target.value)}
          />
        </div>
        <div className="filter-group">
          <label>Limit:</label>
          <input
            type="number"
            value={filters.limit}
            onChange={(e) => handleFilterChange('limit', parseInt(e.target.value) || 100)}
            min="1"
            max="1000"
          />
        </div>
        <button onClick={handleApplyFilters} className="apply-filters-button">
          Apply Filters
        </button>
      </div>

      {loading ? (
        <div className="loading">Loading logs...</div>
      ) : (
        <div className="logs-table-container">
          <table className="logs-table">
            <thead>
              <tr>
                <th>Timestamp</th>
                <th>Username</th>
                <th>Status</th>
                <th>Failure Reason</th>
                <th>IP Address</th>
                <th>User Agent</th>
              </tr>
            </thead>
            <tbody>
              {logs.length === 0 ? (
                <tr>
                  <td colSpan="6" className="no-logs">No login logs found</td>
                </tr>
              ) : (
                logs.map((log) => (
                  <tr key={log.id}>
                    <td>{(() => {
                      try {
                        let dateString = String(log.created_at).trim();
                        
                        const utcDate = new Date(dateString);
                        const pstTime = utcToZonedTime(utcDate, 'America/Los_Angeles');
                        pstTime.setHours(pstTime.getHours());
                        return format(pstTime, 'MMM d, yyyy h:mm:ss a') + ' PST';
                      } catch (error) {
                        return log.created_at || 'N/A';
                      }
                    })()}</td>
                    <td>{log.username}</td>
                    <td>{getStatusBadge(log.attempt_type)}</td>
                    <td>{log.failure_reason || '-'}</td>
                    <td>{log.ip_address}</td>
                    <td className="user-agent">{log.user_agent}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default LoginLogs;
